import GoingBack from "../../components/GoingBack/GoingBack";
import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import GetProductById from "../../services/GetProductById";
import IsAdmin from "../../components/Admin/IsAdmin";
import Cookies from "js-cookie";
import uploadImage from "../../services/UploadImage";
import formValid from "../../services/FormProductValid";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import UpdateOrCreateAnewStripeProductId from "../../services/UpdateOrCreateAnewStripeProductId";
import './AdminModern.scss';

function AdminProductInDetails() {
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState(null);
    const [product, setProduct] = useState(null);
    const [productTitle, setProductTitle] = useState("");
    const [productDescription, setProductDescription] = useState("");
    const [productPrice, setProductPrice] = useState("");
    const [productImage, setProductImage] = useState("");
    const [productCategory, setProductCategory] = useState("");
    const [productSousCategory, setProductSousCategory] = useState("");
    const [productPierres, setProductPierres] = useState("");
    const [productColors, setProductColors] = useState("");
    const [productOnSale, setProductOnSale] = useState(false);
    const {id} = useParams();
    const [image, setImage] = useState([]);
    const [fileName, setFileName] = useState('Cliquez ici pour ajouter de nouvelles photos');
    const [lienImageProduit, setLienImageProduit] = useState([]);
    const [conditionsRemplies, setConditionsRemplies] = useState(false);
    const [idPrixStripe, setIdPrixStripe] = useState(null);

    useEffect(() => {
        if (isAdmin === null) {
            return;
        }
        !isAdmin && navigate("/");
    }, [isAdmin]);

    useEffect(() => {
        GetProductById(id, setProduct);
    }, []);

    useEffect(() => {
        if (!product) {
            return;
        }
        setProductTitle(product[0].name);
        setProductDescription(product[0].description);
        setProductPrice((product[0].price).toFixed(2));
        setProductCategory(product[0].category);
        let transformedColors = product[0].color.map(color => color.replace(/ /g, "_"));
        setProductColors(transformedColors.join(","));
        let transformedPierres = product[0].pierres.map(pierre => pierre.replace(/ /g, "_"));
        setProductPierres(transformedPierres.join(","));
        setProductSousCategory(product[0].secondary_category);
        setProductImage(product[0].covers);
        setProductOnSale(product[0].onSale);
    }, [product]);

    const updateProduct = async () => {
        if (await formValid(productTitle, productCategory, productDescription, productSousCategory, productPrice, image) === false) {
            Swal.fire({
                text: "Veuillez remplir tous les champs.",
                icon: "error",
                showConfirmButton: true
            })
            return;
        }
        if (productPrice !== product[0].price) {
            const simpleProduct = {
                name: productTitle,
                description: productDescription,
                images: [productImage],
                price: productPrice
            }
            const idPrixStripe = product[0].idPrixStripe;
            await UpdateOrCreateAnewStripeProductId(simpleProduct, idPrixStripe, setIdPrixStripe);
        }
        if (image.length > 0) {
            await uploadImage(formValid(productTitle, productCategory, productDescription, productSousCategory, productPrice, image), setLienImageProduit, image)
        }
        setConditionsRemplies(true);
    }

    const handleClickDeleteImage = (index) => {
        const newImages = product[0].covers.filter((cover, i) => i !== index);
        setProduct(prevState => {
            return [{...prevState[0], covers: newImages}];
        });
    }

    const handleImageUpload = event => {
        const files = Array.from(event.target.files);
        setImage(files);
        const fileNames = files.map(file => file.name).join('\n');
        setFileName(fileNames);
    };

    useEffect(() => {
        const updateProduct = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}products/update/${id}`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get("auth_token")}`,
                    },
                    body: JSON.stringify({
                        name: productTitle,
                        description: productDescription,
                        price: productPrice,
                        category: productCategory,
                        secondary_category: productSousCategory,
                        covers: product[0].covers.concat(lienImageProduit),
                        onSale: productOnSale,
                        pierres: productPierres === "" ? null : productPierres,
                        color: productColors === "" ? null : productColors,
                        idPrixStripe: idPrixStripe ? idPrixStripe.idPrixStripe : null
                    }),
                });
                const data = await response.json();
                if (response.ok) {
                    Swal.fire({
                        text: "Produit modifié avec succès.",
                        toast: true,
                        position: "top-end",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        icon: "success"
                    }).then(() => {
                        navigate(-1);
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }
        if(conditionsRemplies) {
            updateProduct();
            setConditionsRemplies(false);
        }
    }, [lienImageProduit, conditionsRemplies, idPrixStripe]);

    return (
        <div className="admin-modern-container">
            <IsAdmin setAdmin={setIsAdmin}/>
            <GoingBack/>
            {!isAdmin ? null : (
                <>
                    <div className="admin-header">
                        <h2>Formulaire de modification d'un produit</h2>
                        <p>Modifiez les informations du produit sélectionné</p>
                    </div>
                    
                    <div className="admin-card" style={{ maxWidth: "800px", margin: "0 auto" }}>
                        <div className="admin-grid-2">
                            <div className="admin-form-group">
                                <label>Nom du produit</label>
                                <input className="admin-input" type="text"
                                       value={productTitle}
                                       onChange={(e) => setProductTitle(e.target.value)}
                                />
                            </div>
                            
                            <div className="admin-form-group">
                                <label>Prix Produit (€)</label>
                                <input className="admin-input" type="number"
                                       value={productPrice}
                                       onChange={(e) => setProductPrice(e.target.value)}/>
                            </div>
                            
                            <div className="admin-form-group" style={{ gridColumn: "1 / -1" }}>
                                <label>Description du produit</label>
                                <textarea className="admin-input" style={{ resize: "vertical", minHeight: "100px" }}
                                       value={productDescription}
                                       onChange={(e) => setProductDescription(e.target.value)}/>
                            </div>

                            <div className="admin-form-group">
                                <label>Catégorie du produit</label>
                                <select className="admin-select" value={productCategory} onChange={(e) => setProductCategory(e.target.value)}>
                                    <option value="">Choisir une catégorie</option>
                                    <option value="Bijoux">Bijoux et accessoires</option>
                                    <option value="Zen">Ambiance zen</option>
                                    <option value="Bien etre">Bien être</option>
                                </select>
                            </div>

                            <div className="admin-form-group">
                                <label>Sous catégorie du produit</label>
                                <select className="admin-select" value={productSousCategory}
                                        onChange={(e) => setProductSousCategory(e.target.value)}>
                                    <option value="">Choisir une sous-catégorie</option>
                                    {(productCategory === "Bijoux") && (
                                        <>
                                            <option value="Bracelet">Bracelet</option>
                                            <option value="Boucle Oreille">Boucles d'oreilles</option>
                                            <option value="Accessoire">Accessoire</option>
                                        </>
                                    )}
                                    {(productCategory === "Zen") && (
                                        <>
                                            <option value="Lampe sel">Lampe de sel</option>
                                            <option value="Fontaine interieur">Fontaine d'intérieur</option>
                                            <option value="Diffuseur">Diffuseur d'ambiance</option>
                                            <option value="bruleur_parfum">Brûleur parfum</option>
                                            <option value="Statue">Statue</option>
                                        </>
                                    )}
                                    {(productCategory === "Bien etre") && (
                                        <>
                                            <option value="Purifier">Purifier - Assainir</option>
                                            <option value="Plateau recharge">Plateau de recharge</option>
                                            <option value="Orgonite">Orgonite</option>
                                        </>
                                    )}
                                </select>
                            </div>

                            {productCategory === "Bijoux" &&
                                <>
                                    <div className="admin-form-group">
                                        <label>Nom des pierres (ex: Diamant,Rubis)</label>
                                        <input className="admin-input" type="text"
                                               value={productPierres}
                                               onChange={(e) => setProductPierres(e.target.value)}/>
                                    </div>
                                    <div className="admin-form-group">
                                        <label>Couleurs (ex: Rouge,Gris)</label>
                                        <input className="admin-input" type="text"
                                               value={productColors}
                                               onChange={(e) => setProductColors(e.target.value)}/>
                                    </div>
                                </>
                            }

                            <div className="admin-form-group" style={{ gridColumn: "1 / -1" }}>
                                <div className="admin-checkbox-group">
                                    <input type="checkbox" checked={productOnSale} id="productOnSale"
                                           onChange={(e) => setProductOnSale(e.target.checked)}/>
                                    <label htmlFor="productOnSale">Produit disponible à l'achat</label>
                                </div>
                            </div>
                            
                            <div className="admin-form-group" style={{ gridColumn: "1 / -1" }}>
                                <label>Images actuelles</label>
                                <div style={{display: "flex", gap: "1rem", flexWrap: "wrap", marginTop: "0.5rem", marginBottom: "1rem"}}>
                                    {product && product[0].covers.map((cover, index) => (
                                        <div key={index} style={{position: "relative", borderRadius: "8px", overflow: "hidden", border: "1px solid #e2e8f0"}}>
                                            <img height={100} width={100} src={cover} style={{objectFit: "cover", display: "block"}} alt={"détails produit collections"}/>
                                            <div style={{position: "absolute", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", opacity: 0, transition: "opacity 0.2s"}}
                                                 onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
                                                 onMouseLeave={(e) => e.currentTarget.style.opacity = 0}>
                                                <FontAwesomeIcon icon={faTrash} style={{cursor: "pointer", fontSize: "1.5em", color: "white"}} onClick={() => handleClickDeleteImage(index)}/>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <label>Ajouter d'autres photos</label>
                                <input type="file" id="file" style={{display: 'none'}} multiple onChange={handleImageUpload}/>
                                <label htmlFor="file" className="admin-file-label">
                                    <svg style={{width:"2rem", height:"2rem", margin:"0 auto 0.5rem auto", display:"block", color:"var(--admin-text-muted)"}} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
                                    {fileName}
                                </label>
                            </div>

                            <div style={{ gridColumn: "1 / -1", marginTop: "1rem" }}>
                                <button className="admin-btn admin-btn-primary" onClick={() => updateProduct()}>
                                    <svg style={{width:"1.2rem", height:"1.2rem"}} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path></svg>
                                    Enregistrer les modifications
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default AdminProductInDetails;